import React, { useEffect, useState } from 'react'
import { styled } from '@creditas/stylitas'
import { Typography } from '@creditas/typography'

import { FlexContainer } from 'components/Flex'
import { formatDateToNow } from 'utils/date'

const ONE_MINUTE_IN_MS = 1000 * 60

const Wrapper = styled(FlexContainer)`
  width: 100%;
  padding: 0;
  margin-top: 20px;
  justify-content: flex-end;
`

export const LastRefreshDate = ({ date }) => {
  const [formatted, setFormatted] = useState('')

  useEffect(() => {
    const update = () => setFormatted(formatDateToNow(date))
    const timeout = setTimeout(update, ONE_MINUTE_IN_MS)
    update()

    return () => window.clearTimeout(timeout)
  })

  return (
    <Wrapper>
      <Typography variant="textSupport">Atualizado há {formatted}</Typography>
    </Wrapper>
  )
}
